import {
  AdminFonctionnelControllerApi,
  PieceJointeTypeResponseDto,
} from 'lib_api/lib/api/gen';

import { Controller } from './types';

export function fetchPieceJointeTypes(
  controller: Controller,
  dossierId: string,
): Promise<PieceJointeTypeResponseDto[]> {
  return getPieceJointeTypes(controller)(dossierId).then(
    (response: PieceJointeTypeResponseDto[]) => {
      return response;
    },
  );
}

function getPieceJointeTypes(controller: Controller) {
  return controller instanceof AdminFonctionnelControllerApi
    ? controller.getPieceJointeTypesUsingGET1.bind(controller)
    : controller.getPieceJointeTypesUsingGET.bind(controller);
}
